import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { LuxonDateHelper } from "@/Common/Helpers/LuxonDateHelper";
import { DocumentAnnotationLog } from "@/Documents/Api/Dto/Response/DocumentAnnotationLog";

interface IAnnotationLogsProps {
    /**
     * Annotation log item.
     */
    logs: DocumentAnnotationLog[];
}

/**
 * Component that render Annotation log information.
 * @param {IAnnotationLogsProps} props The component properties.
 */
function AnnotationLogs(props: IAnnotationLogsProps): JSX.Element {
    const { getText } = useTranslation();

    return (
        <ul>
            {props.logs.map(annotationLog => (
                <li key={annotationLog.Id}>
                    <div className="flex-row">
                        <div className="bold">
                            {cacheStore.GetLookupById(annotationLog.PrefixLookupId)?.GetValue()} {annotationLog.LastName}, {annotationLog.FirstName}
                            <span className="separator">{getText("OnLowerLabel")}</span>
                        </div>
                        {LuxonDateHelper.formatToFullDateTime(annotationLog.UpdateDate)}
                    </div>
                </li>
            ))}
        </ul>
    );
}

export { AnnotationLogs };
